import UserDatalist from "@/components/entities/app/user/UserDatalist";
const UserDatalistPage = () => {
    return (
        <div>
            <UserDatalist />
        </div>
    );
}

export default UserDatalistPage;
